import { STATUS_ENUM } from './reducers.types';

export interface UserTeamAccessState extends UserTeamAccess {
	enabled?: boolean;
	status: STATUS_ENUM;
}

export interface UserTeamAccess {
	canCreateInfo360Hubs: boolean;
	projectsExists: boolean | null;
	hubExists: boolean | null;
	isHubAdmin: boolean | null;
	hasInfo360Licenses: boolean | null;
	teamInfo: string;
	hubAccountId: string;
}

export interface LandingPageAccessState extends LandingPageAccess {
	status: STATUS_ENUM;
}

type HubRegion = 'US' | 'EMEA' | 'AUS' | 'EU' | 'APAC';

export interface LandingPageAccess {
	isTeamAdmin: boolean;
	isHubAdmin: boolean;
	eligibleTeams: string[];
	adminHubs: {
		hubId: string;
		hubRegion: HubRegion;
		accountId: string;
	}[];
}
